/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nucleic acids absorb at 260 nm in proportion to concentration. Multiplying the absorbance by the dilution factor and a type-specific factor (50, 33 or 40 µg/mL per OD) gives the concentration.`)
};

const es_od_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los ácidos nucleicos absorben a 260 nm en proporción a la concentración. Multiplicar la absorbancia por el factor de dilución y un factor específico del tipo (50, 33 o 40 µg/mL por OD) da la concentración.`)
};

const de_od_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nukleinsäuren absorbieren bei 260 nm proportional zur Konzentration. Die Multiplikation der Absorption mit dem Verdünnungsfaktor und einem typspezifischen Faktor (50, 33 oder 40 µg/mL pro OD) ergibt die Konzentration.`)
};

const nl_od_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nucleïnezuren absorberen bij 260 nm evenredig met de concentratie. Het vermenigvuldigen van de absorptie met de verdunningsfactor en een typespecifieke factor (50, 33 of 40 µg/mL per OD) geeft de concentratie.`)
};

const fr_od_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les acides nucléiques absorbent à 260 nm proportionnellement à la concentration. Multiplier l'absorbance par le facteur de dilution et un facteur spécifique au type (50, 33 ou 40 µg/mL par OD) donne la concentration.`)
};

const it_od_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli acidi nucleici assorbono a 260 nm in proporzione alla concentrazione. Moltiplicare l'assorbanza per il fattore di diluizione e un fattore specifico del tipo (50, 33 o 40 µg/mL per OD) dà la concentrazione.`)
};

const pt_br2_od_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ácidos nucleicos absorvem a 260 nm proporcionalmente à concentração. Multiplicar a absorbância pelo fator de diluição e por um fator específico do tipo (50, 33 ou 40 µg/mL por OD) fornece a concentração.`)
};

const pt_od_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os ácidos nucleicos absorvem a 260 nm proporcionalmente à concentração. Multiplicar a absorvância pelo fator de diluição e por um fator específico do tipo (50, 33 ou 40 µg/mL por OD) dá a concentração.`)
};

const ja_od_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核酸は260 nmで濃度に比例して吸収します。吸光度に希釈倍率と種類ごとの係数 (OD1あたり50、33、または40 µg/mL) を掛けると濃度が得られます。`)
};

const zh_od_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`核酸在 260 nm 处的吸光度与浓度成正比。将吸光度乘以稀释倍数和特定类型系数（每个 OD 对应 50、33 或 40 µg/mL）即可得到浓度。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_faq_a1", locale)
	if (locale === "en") return en_od_faq_a1(inputs)
	if (locale === "es") return es_od_faq_a1(inputs)
	if (locale === "de") return de_od_faq_a1(inputs)
	if (locale === "nl") return nl_od_faq_a1(inputs)
	if (locale === "fr") return fr_od_faq_a1(inputs)
	if (locale === "it") return it_od_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_od_faq_a1(inputs)
	if (locale === "pt") return pt_od_faq_a1(inputs)
	if (locale === "ja") return ja_od_faq_a1(inputs)
	return zh_od_faq_a1(inputs)
};